<template>
    <div
        class="search-box"
        v-if="show && menuCategories.length > 0"
    >
        <div class="has-search autocomplete">
            <div class="">
                <span
                    class="fa form-control-feedback"
                    :class="[isLoading ? 'fa-spinner' : 'fa-search']"
                ></span>
                <div class="input-group flex-nowrap">
                    <!-- ref="boxGroup" -->
                    <!-- :disabled="disabled || isLoading" -->
                    <div
                        class="autocomplete-input-group"
                        :class="{ 'autocomplete-selected': value }"
                    >
                        <input
                            ref="inputSearch"
                            name="search"
                            type="search"
                            autocomplete="one-time-code"
                            class="form-control"
                            aria-label="query"
                            :placeholder="menuPlaceholder"
                            :disabled="disabled"
                            v-model.trim="query"
                            @blur="blur"
                            @focus="focus"
                            @input="onSearch"
                            @keydown.down="keyDown"
                            @keydown.up="keyUp"
                            @keydown.enter="keyEnter"
                            @keydown.tab="keyEnter"
                        />
                    </div>
                    <div
                        class="input-group-append position-relative"
                        v-if="query"
                    >
                        <button
                            class="btn btn-default text-right min-w-auto px-2 py-0 d-flex align-items-center justify-content-center"
                            type="button"
                            @click="clearSearchQuery"
                        >
                            <span class="d-flex align-items-center justify-content-center">
                                <i
                                    style="font-size: 1.1rem"
                                    class="fas fa-times-circle"
                                ></i>
                            </span>
                        </button>
                    </div>
                    <div
                        class="input-group-append position-relative"
                        v-if="menuCategories.length > 1"
                    >
                        <button
                            class="btn btn-default dropdown-toggle text-right min-w-auto pl-2"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {{ menuLabel }}
                            <span class="pl-2">
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="angle-down"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 256 512"
                                    class="rotate-icon right svg-inline--fa fa-angle-down fa-w-12 fa-1x"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"
                                        class=""
                                    ></path>
                                </svg>
                            </span>
                        </button>
                        <div class="dropdown-menu">
                            <template v-for="(item, idx) in menuCategories">
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    @click.prevent="setCategory(item)"
                                    :key="`item-${idx}`"
                                >
                                    {{ $t(item.name) }}
                                </a>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="autocomplete-list"
                v-show="showMenu"
            >
                <!-- :style="{width: boxWidth}" -->
                <div class="autocomplete-list-items">
                    <template v-for="(item, i) in internalItems">
                        <div
                            class="autocomplete-list-element"
                            :key="`group-${i}`"
                        >
                            <span
                                v-if="item.__group"
                                class="autocomplete-list-option autocomplete-list-group"
                            >
                                <span>{{ item.__group }}</span>
                            </span>
                        </div>
                        <div
                            class="autocomplete-list-element"
                            :key="`element-${i}`"
                        >
                            <div
                                class="autocomplete-list-option autocomplete-list-item"
                                :class="{ 'autocomplete-item-active': i === arrowCounter }"
                                @click.prevent="onClickItem(item)"
                                @mouseover="arrowCounter = i"
                            >
                                <slot
                                    name="item"
                                    :item="item"
                                >
                                    <span v-html="highlight(getItemList(item))"></span>
                                    <span
                                        class="sublabel"
                                        v-if="item.__subLabel"
                                        >&nbsp;{{ item.__subLabel }}</span
                                    >
                                </slot>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isString, isObject, isArray, isEmpty, debounce, formatUrl } from "@config/utils";

function sanitize(text) {
    return text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export default {
    timeout: null,
    props: {
        moduleCode: {
            type: String,
            require: true,
            default: null
        },
        labelMenu: {
            type: String,
            default: "Category"
        },
        placeholder: {
            type: String,
            default: "query for..."
        },
        labelNoResults: {
            type: String,
            default: "Sem Resultados..."
        },
        addrCategory: {
            type: Object,
            default: () => ({})
        },
        value: {
            default: null
        },
        // maxMatches: {
        //     type: Number,
        //     default: 10
        // },
        wait: {
            type: Number,
            default: 200
        },
        getLabel: {
            type: Function,
            default: item => item
            // default: item => item
        },
        items: {
            type: Array,
            required: false,
            default: () => []
            // default: () => ['Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'AndorrA', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote D\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and Mcdonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India'],
        },
        isAsync: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        keepOpen: {
            type: Boolean,
            default: false
        },
        autoSelectOneItem: {
            type: Boolean,
            default: true
        },
        callback: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            showList: false,
            idPanel: "navsearch",
            // categories: [
            //     {'id': 'mb-oco', 'name': 'Ocorrência', 'url': '/meubairro/occurrence/get-codes/:query', label: 'code'},
            // ],
            category: null,
            query: "",
            internalItems: this.items || [],
            isLoading: false,
            arrowCounter: -1
            // boxWidth: '100%',
        };
    },
    computed: {
        getPanel() {
            return this.idPanel && this.moduleCode ? this.$store.getters.getPanel(this.moduleCode, this.idPanel) : {};
        },
        url() {
            return this.getPanel.url || {};
        },
        show() {
            return !!this.getPanel?.show;
        },
        searchConfig() {
            return this.getPanel?.search || {};
        },
        minLen() {
            return (this.category || {})?.minLen ?? this.searchConfig.minLen ?? 2;
        },
        categories() {
            return this.getPanel?.categories || [];
        },
        filteredCategories() {
            return this.categories.filter(item => !item.acl || (item.acl && this.$auth.check(item.acl)));
        },
        menuCategories() {
            let items = [];
            if (isObject(this.addrCategory) && !isEmpty(this.addrCategory)) {
                items.push(this.addrCategory);
            } else if (isArray(this.addrCategory)) {
                items = [...items, ...this.addrCategory];
            }
            return [...items, ...this.filteredCategories];
        },
        menuLabel() {
            // return this.category ? this.category == this.addrCategory ? '' : this.category.name : this.labelMenu;
            return "";
        },
        menuPlaceholder() {
            return this.$t(this.category ? (this.category.placeholder ? this.category.placeholder : this.placeholder) : this.placeholder);
        },
        hasItems() {
            return !!this.internalItems.length;
        },
        showMenu() {
            return (this.showList && this.hasItems) || this.keepOpen;
        },
        urlAsync() {
            return this.category ? this.category.url : null;
        },
        resultLimit() {
            return this.category && this.category.limit ? this.category.limit : "";
        },
        labelTemplate() {
            return this.category ? this.category.labelTemplate : null;
        },
        // labelConfig() {
        //     return this.category ? this.category.label : 'name';
        // },
        listTemplate() {
            return this.category ? this.category.listTemplate : null;
        },
        // labelListConfig() {
        //     console.log('labelListConfig:', this.category);
        //     return this.category ? this.category.listLabel : this.labelConfig;
        // },
        groupListConfig() {
            return this.category ? this.category.listGroup : null;
        },
        subLabelTemplate() {
            return this.category ? this.category.subLabelTemplate : null;
        },
        orderBy() {
            // Multiples separated by ";"
            // EX: 'name;adminName1'
            // EX: 'name,desc;adminName1,asc'
            // EX: 'name;adminName1,asc'
            // EX: 'name;adminName1,desc'
            let orderBy = this.category?.orderBy ?? [];
            return isString(orderBy) ? orderBy.split(';') : orderBy;
        },
        highlight() {
            if (this.isAsync) {
                return text => {
                    return text;
                };
            }
            return text => {
                text = sanitize(text);
                if (this.query.length === 0) {
                    return text;
                }
                const re = new RegExp(this.escapedQuery, "gi");
                return text.replace(re, `<strong>$&</strong>`);
            };
        },
        escapedQuery() {
            return escapeRegExp(sanitize(this.query));
        }
    },
    created() {
        this.onSelectItem(this.value);
    },
    mounted() {
        this.setCategory();
        this.$nextTick(() => {
            document.addEventListener("click", this.handleClickOutside);
            // this.boxWidth = this.calcBoxWidth();
        });
    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        setSearch(params) {
            this.$store.dispatch(`setPanel`, {
                id: this.idPanel,
                module: this.moduleCode,
                search: {
                    category: this.category,
                    ...params
                }
            });
        },
        setCategory(cat = null) {
            this.query = null;
            this.onSelectItem(null);
            this.showList = false;
            this.arrowCounter = -1;
            this.category = cat ? cat : this.menuCategories.length > 0 ? this.menuCategories[0] : null;
            if (cat && this.$refs.inputSearch) {
                this.$refs.inputSearch.focus();
            }
            this.setSearch({
                item: null
            });
        },
        onSearch: function (evt) {
            if (evt.target && evt.target.value === "") {
                this.showList = false;
                this.setItems([]);
                this.onSelectItem(null);
            } else {
                debounce(() => {
                    // Is the data given by an outside ajax request?
                    if (this.isAsync) {
                        // this.isLoading = true;
                        // this.onSelectItem(null);
                        this.callUpdateItems(this.query, this.updateItems);
                    } else {
                        // Data is sync, we can query our flat array
                        this.filterResults();
                        this.showList = true;
                        this.arrowCounter = -1;
                    }
                })();
            }
            // Let's warn the parent that a change was made
            this.$emit("change", this.query);
        },
        onClickItem(item) {
            if (item.noresults) {
                return;
            }
            this.onSelectItem(item);
            this.$emit("item-clicked", item);
        },
        onSelectItem(item) {
            if (item) {
                this.showList = false;
                this.query = this.getItemLabel(item);
                this.$emit("item-selected", item);
            } else {
                this.setItems(this.items);
            }
            this.setSearch({ item });
            this.$emit("input", item);
        },
        updateItems() {
            // if (this.isLoading) {
            //     return;
            // }
            this.isLoading = true;
            this.showList = true;
            this.arrowCounter = -1;
            this.onSelectItem(null);
            this.makeSearch();
            this.$emit("update-items", this.query);
        },
        setItems(items) {
            this.internalItems = items || [];
        },
        isSelectedValue(value) {
            return 1 == this.internalItems.length && value == this.internalItems[0];
        },
        isUpdateItems(text) {
            if (text.length >= this.minLen) {
                return true;
            }
        },
        callUpdateItems(text, cb) {
            clearTimeout(this.$options.timeout);
            if (this.isUpdateItems(text)) {
                this.$options.timeout = setTimeout(cb, this.wait);
            }
        },
        findItem(text) {
            if (!text) {
                return;
            }
            if (this.autoSelectOneResult && this.internalItems.length == 1) {
                return this.internalItems[0];
            }
        },
        filterResults() {
            this.setItems(this.items.filter(item => item.toLowerCase().indexOf(this.query.toLowerCase()) > -1));
            // if (this.query.length === 0 || this.query.length < this.minLen) {
            //     return [];
            // }
            // const re = new RegExp(this.escapedQuery, 'gi');
            // // Filter, sort, and concat
            // return this.items
            //     .filter(i => i.text.match(re) !== null)
            //     .sort((a, b) => {
            //         const aIndex = a.text.indexOf(a.text.match(re)[0])
            //         const bIndex = b.text.indexOf(b.text.match(re)[0])
            //         if (aIndex < bIndex) { return -1 }
            //         if (aIndex > bIndex) { return 1 }
            //         return 0
            //     }).slice(0, this.maxMatches);
        },
        keyDown() {
            if (this.arrowCounter < this.internalItems.length - 1) {
                this.arrowCounter++;
                this.itemView(this.$el.getElementsByClassName("autocomplete-list-item")[this.arrowCounter]);
            }
        },
        keyUp() {
            if (this.arrowCounter > -1) {
                this.arrowCounter--;
                this.itemView(this.$el.getElementsByClassName("autocomplete-list-item")[this.arrowCounter]);
            }
        },
        keyEnter() {
            if (this.showList && this.internalItems[this.arrowCounter]) {
                this.onSelectItem(this.internalItems[this.arrowCounter]);
                this.showList = false;
                this.arrowCounter = -1;
            }
        },
        focus(evt) {
            if (evt.target && evt.target.value === "") {
                return;
            } else {
                this.$emit("focus", this.query);
                this.showList = true;
            }
        },
        blur() {
            this.$emit("blur", this.query);
            setTimeout(() => (this.showList = false), 200);
        },
        itemView(item) {
            if (item && item.scrollIntoView) {
                item.scrollIntoView(false);
            }
        },
        async makeSearch() {
            // Items have already been requested
            // if (this.isLoading) {
            //     return;
            // }
            if (!this.urlAsync) {
                return;
            }

            let params = {
                q: this.query,
                limit: this.resultLimit
            };

            await this.$http
                .get(formatUrl(this.urlAsync, params), { params })
                .then(({ data }) => {
                    let items = data.data;
                    this.setResults(items ? items : []);
                })
                .finally(() => {
                    this.isLoading = false;
                })
                .catch(error => {
                    this.showError(error);
                });
        },
        setResults(data) {
            if (data.length == 0) {
                data.push({ id: null, noresults: this.labelNoResults });
            }
            let groupProperty = this.groupListConfig;
            if (groupProperty) {
                let groups = [];

                this.orderBy.forEach(function(orderBy) {
                    const _config = orderBy.split(',');
                    let property = _config[0];
                    let direction = (_config.length > 1 ? _config[1] : 'asc').toLowerCase();
                    data = data.sort((a, b) => {
                        if (a.hasOwnProperty(property) && b.hasOwnProperty(property)) {
                            if(direction == 'desc') {
                                if (a[property] < b[property]) {
                                    return 1;
                                }
                                if (a[property] > b[property]) {
                                    return -1;
                                }
                                return 0;
                            }else{
                                if (a[property] < b[property]) {
                                    return -1;
                                }
                                if (a[property] > b[property]) {
                                    return 1;
                                }
                                return 0;
                            }
                        }
                        return 1;
                    });
                });

                data.map(item => {
                    if (item.hasOwnProperty(groupProperty)) {
                        let lblGrp = item[groupProperty];
                        if (!groups.includes(lblGrp)) {
                            groups.push(lblGrp);
                            item["__group"] = lblGrp;
                        }
                    }
                });
                groups = null;
            }
            let subLabelTemplate = this.subLabelTemplate;
            if (subLabelTemplate) {
                data.map(item => {
                    item["__subLabel"] = this.templater(subLabelTemplate, item);
                });
            }

            this.setItems(data);
            let item = this.findItem(this.query);
            if (item) {
                this.onSelectItem(item);
                this.showList = false;
            } else {
                this.showList = true;
                this.arrowCounter = -1;
            }
        },
        getItemLabel(item) {
            return item.noresults ? item.noresults : this.templater(this.labelTemplate, item);
        },
        getItemList(item) {
            return item.noresults ? item.noresults : this.listTemplate ? this.templater(this.listTemplate, item) : this.getItemLabel(item);
        },
        // calcBoxWidth() {
        //     return this.$refs.boxGroup ? this.$refs.boxGroup.clientWidth-12*2 + 'px' : '100%';
        // },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.showList = false;
                this.arrowCounter = -1;
            }
        },
        showError: function (error) {
            this.$root.$helper.error.httpError(error);
        },
        templater: function (string, obj) {
            return this.$root.$helper.string.interpolate(this.$t(string), obj);
        },
        clearSearchQuery() {
            this.query = "";
            this.onSearch({ target: { value: this.query } });
        }
    },
    watch: {
        items: function (newValue, oldValue) {
            // we want to make sure we only do this when it's an async request
            if (this.isAsync) {
                this.setItems(newValue);
                let item = this.findItem(this.query);
                if (item) {
                    this.onSelectItem(item);
                    this.showList = false;
                } else {
                    this.showList = true;
                    this.arrowCounter = -1;
                }
                this.isLoading = false;
            }
        },
        value(newValue) {
            if (!this.isSelectedValue(newValue)) {
                this.onSelectItem(newValue);
                this.query = this.getItemLabel(newValue);
            }
        }
        // query (value) {
        //     if (!value) {
        //       return
        //     }
        //     // Debounce the input and wait for a pause of at
        //     // least 200 milliseconds.
        //     debounce(this.makeSearch, 200)(value, this);
        // },
        // showList (newValue) {
        //     if (newValue ) {
        //         this.boxWidth = this.calcBoxWidth();
        //     }
        // },
    }
};
</script>

<style lang="scss" scoped>
@import "@styles/bootstrap/_mixins.scss";

input[type="search"][name="search"] {
    &::-webkit-search-cancel-button {
        display: none;
    }
}

.search-box {
    display: inline-block;

    @include media-breakpoint-down(sm) {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin-inline: auto;
        width: fit-content;
    }
}
</style>
